"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RetainableModal = exports.useRetainedModalToggle = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var react_simple_cookie_store_1 = require("react-simple-cookie-store");
var Modal_1 = require("./Modal");
var useRetainedModalToggle = function (name) {
    var KEEP_MODAL_OPEN = "KEEP_" + name + "_MODAL_OPEN";
    var _a = (0, react_1.useState)({
        keepOpen: (0, react_simple_cookie_store_1.getCookie)(KEEP_MODAL_OPEN) === "true",
    }), state = _a[0], setState = _a[1];
    var toggleKeepOpen = function () {
        setState({ keepOpen: !state.keepOpen });
        (0, react_simple_cookie_store_1.setCookie)(KEEP_MODAL_OPEN, "" + !state.keepOpen, 999);
    };
    return { keepOpen: state.keepOpen, toggleKeepOpen: toggleKeepOpen };
};
exports.useRetainedModalToggle = useRetainedModalToggle;
var RetainableModal = function (_a) {
    var name = _a.name, children = _a.children, keepOpen = _a.keepOpen, toggleKeepOpen = _a.toggleKeepOpen, modalProps = __rest(_a, ["name", "children", "keepOpen", "toggleKeepOpen"]);
    return ((0, jsx_runtime_1.jsxs)(Modal_1.Modal, __assign({}, modalProps, { children: [children, (0, jsx_runtime_1.jsxs)("label", __assign({ htmlFor: "keepOpen", onClick: toggleKeepOpen, style: {
                    display: "block",
                    cursor: "pointer",
                    marginTop: "10px",
                } }, { children: [(0, jsx_runtime_1.jsx)("input", { type: "checkbox", name: "keepOpen", checked: keepOpen, onClick: toggleKeepOpen }, void 0), " ", "Keep window open after save?"] }), void 0)] }), void 0));
};
exports.RetainableModal = RetainableModal;
